<script lang="ts">
    export let title: string;
    export let nbCols: number;
</script>

<div class="bg-white px-[40px] py-[32px]">
    <div class="text-gray-800 text-22/[120%] font-bold text-center">{title}</div>
    <div
        class="mt-[24px] grid grid-cols-var-nb-cols"
        style={`--grid-nb-cols: ${nbCols};`}
    >
        <slot />
    </div>
</div>
